import axios from "axios";
import initializeAxios from "../util/Axios";

class AuthServices  {
  constructor() {
    initializeAxios();
    console.log("Initializing axios")
	}
  
  async signIn(email, password) {
    const response = await axios.post("/api/auth/login", {
      email,
      password,
    });

    return response.data;
  }
}

export default new AuthServices();
